export default function CopyLinkIcon({ className }: { className?: string }) {
  return (
    <svg
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      width="21"
      height="20"
      viewBox="0 0 21 20"
      fill="none">
      <path
        d="M4.27107 13.9475C4.01552 13.8018 3.80296 13.5912 3.65488 13.3371C3.5068 13.0829 3.42844 12.7942 3.42773 12.5V4.16667C3.42773 3.25 4.17773 2.5 5.0944 2.5H13.4277C14.0527 2.5 14.3927 2.82083 14.6777 3.33333M6.76107 8.05583C6.76107 7.46639 6.99522 6.90109 7.41202 6.48429C7.82882 6.06749 8.39412 5.83333 8.98357 5.83333H16.2052C16.4971 5.83333 16.7861 5.89082 17.0557 6.00251C17.3254 6.1142 17.5704 6.27791 17.7768 6.48429C17.9832 6.69067 18.1469 6.93567 18.2586 7.20532C18.3702 7.47497 18.4277 7.76397 18.4277 8.05583V15.2775C18.4277 15.5694 18.3702 15.8584 18.2586 16.128C18.1469 16.3977 17.9832 16.6427 17.7768 16.849C17.5704 17.0554 17.3254 17.2191 17.0557 17.3308C16.7861 17.4425 16.4971 17.5 16.2052 17.5H8.98357C8.6917 17.5 8.4027 17.4425 8.13305 17.3308C7.86341 17.2191 7.6184 17.0554 7.41202 16.849C7.20564 16.6427 7.04194 16.3977 6.93025 16.128C6.81855 15.8584 6.76107 15.5694 6.76107 15.2775V8.05583Z"
        stroke="currentColor"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
}
